import { useAtom, useAtomValue } from 'jotai'
import {
  existingCustomerAtom,
  existingCustomerValidationAtom,
  showValidationErrorsAtom
} from '../atoms/reviewCustomer.atoms'
import { CustomerSelect, getLogoSrc } from 'Customer/index'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useQuery } from '@sequencehq/api'
import { getBillingAddress } from '@sequencehq/api/utils/commonModels'
import { CustomerCard, Box } from '@sequencehq/core-components'
import { getPrimaryBillingContact } from 'CustomerContacts/index'
import { BorderRadius8, GreyGrey30 } from '@sequencehq/core-components'

export const ExistingCustomerForm = () => {
  const [formData, setFormData] = useAtom(existingCustomerAtom)
  const validationState = useAtomValue(existingCustomerValidationAtom)
  const showValidationErrors = useAtomValue(showValidationErrorsAtom)
  const customerQuery = useQuery(
    dashboard20240730Client.getCustomer,
    {
      id: formData.id
    },
    {
      enabled: !!formData.id
    }
  )

  return (
    <Box>
      <CustomerSelect
        data-testid="customer.existing.customerId"
        label="Customer"
        value={formData.id}
        onChange={(customerId: string) => {
          setFormData({
            ...formData,
            id: customerId
          })
        }}
        validationErrors={
          showValidationErrors && validationState.id.length
            ? validationState.id.map(error => ({
                message: error,
                field: 'id'
              }))
            : []
        }
      />
      {customerQuery.data && (
        <Box
          padding="16px"
          border={`1px solid ${GreyGrey30}`}
          borderRadius={BorderRadius8}
          data-testid="customer.existing.customerPreview"
        >
          <CustomerCard
            legalName={customerQuery.data.legalName}
            taxStatus={customerQuery.data.taxStatus}
            customerId={customerQuery.data.id}
            address={
              getBillingAddress(customerQuery.data.addresses) ?? undefined
            }
            billingEmail={
              getPrimaryBillingContact(customerQuery.data.contacts ?? [])?.email
            }
            logoSrc={getLogoSrc(customerQuery.data)}
          />
        </Box>
      )}
    </Box>
  )
}
